<template>
  <v-layout column wrap>
    <v-tooltip v-for="category in categories" left>
      <template v-slot:activator="{ on }">
        <div style="margin-top: 8px; margin-left: 6px;">
          <p
            class="count"
            v-bind:style="{backgroundColor: category.color, color: category.dark ? 'white' : 'black'}"
            v-on="on"
          >{{ countsForCategories()[category.key] }} {{ category.letter }}</p>
        </div>
      </template>
      <p>{{category.name}}</p>
    </v-tooltip>
    <v-tooltip v-if="showCustomersInApp" left>
      <template v-slot:activator="{ on }">
        <div style="margin-top: 8px; margin-left: 6px;">
          <p
            class="count"
            v-bind:style="{backgroundColor: '#77b1ff', color: 'white', fontSize: '40px'}"
            v-on="on"
          >{{ customersInApp }}</p>
        </div>
      </template>
      <p>Customers Booking in App</p>
    </v-tooltip>
  </v-layout>
</template>

<script>
import { Overwatch } from "@/components/util/Overwatch.js";

export default {
  name: "taxi_map_state_summary",
  model: {
    prop: "content",
    event: "input"
  },
  props: {
    taxis: Array,
    bookings: Array,
    rideTypes: Array,
    customersInApp: {
      type: Number,
      default: null
    },
    showCustomersInApp: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    categories: function() {
      return Overwatch.CATEGORIES();
    },
    enabledRideTypes: function() {
      if (this.rideTypes == null) {
        return [];
      }
      return this.rideTypes.filter(function(rt) {
        return rt.enabled == true;
      });
    }
  },
  data() {
    return {
      ABOUT_TO_CLEAR_TIME: 1,
      LATE_TAXIS_ASAP_TIME: 10
    };
  },
  methods: {
    countsForCategories: function() {
      try {
        var state_counts = {
          available: 0,
          running_late: 0,
          en_route: 0,
          about_to_clear: 0,
          pob: 0,
          arrived: 0,
          offline: 0,
          on_break: 0
        };

        var ow = new Overwatch(this.taxis, this.bookings);

        for (var i in this.taxis) {
          var taxi = this.taxis[i];

          if (taxi.offline) {
            state_counts["offline"] += 1;
          }

          if (taxi.follow_on_job_count > 0) {
            // console.log(taxi.follow_on_job_count);

            for (var j = 0; j < taxi.follow_on_job_ids.length; j++) {
              var jobID = taxi.follow_on_job_ids[j];

              var job = ow.getJob(jobID);

              if (job == null) {
                continue;
              }

              var now = new Date().getTime();
              var pickup = job.pickup_timestamp;

              if (job.asap) {
                pickup = pickup + this.LATE_TAXIS_ASAP_TIME * 60 * 1000;
              }

              if (now > pickup) {
                state_counts["running_late"] += 1;
                continue;
              }

              // FOJ are technically en route
              state_counts["en_route"] += 1;
            }
          }

          if (taxi.state == "pob") {
            var job = ow.getJobForTaxi(taxi.id);

            if (job == null) {
              continue;
            }

            var eta = 9999;

            for (var t in job.taxis) {
              var this_taxi = job.taxis[t];
              if (taxi.id == this_taxi.id) {
                if (this_taxi.eta != undefined) {
                  eta = this_taxi.eta;
                }
              }
            }

            if (eta != undefined) {
              if (eta <= this.ABOUT_TO_CLEAR_TIME) {
                state_counts["about_to_clear"] += 1;
                continue;
              }
            }

            state_counts["pob"] += 1;
          } else if (taxi.state == "on_job") {
            var job = ow.getJobForTaxi(taxi.id);

            if (job == null) {
              continue;
            }

            if (job.arrived_time != null) {
              state_counts["arrived"] += 1;
              continue;
            }

            var now = new Date().getTime();
            var pickup = job.pickup_timestamp;

            if (job.asap) {
              pickup = pickup + this.LATE_TAXIS_ASAP_TIME * 60 * 1000;
            }

            if (now > pickup) {
              state_counts["running_late"] += 1;
              continue;
            }

            state_counts["en_route"] += 1;
          } else if (taxi.state == "job_sent" || taxi.state == "available") {
            state_counts["available"] += 1;
          } else if (taxi.state == "on_break") {
            state_counts["on_break"] += 1;
          }
        }
      } catch (e) {
        console.log(e);
      }

      return state_counts;
    },
    stateForTaxi: function(taxi) {
      var ow = new Overwatch(this.taxis, this.bookings);

      return ow.stateForTaxi(taxi, this.$store.state.driverGroups);
    },
    tooltipForTaxi: function(taxi) {
      var ow = new Overwatch(this.taxis, this.bookings);

      return ow.tooltipForTaxi(taxi);
    },
    taxisForRideTypes: function(id, count) {
      if (this.taxis == null) {
        return [];
      }

      var ow = new Overwatch(this.taxis, this.bookings);

      return ow.sortTaxisByState(
        this.taxis.filter(function(t) {
          return t.ride_type_id == id;
        })
      );
    },
    bookingsForRideTypes: function(id) {
      if (this.bookings == null) {
        return [];
      }

      return this.bookings.filter(function(b) {
        return b.ride_type == id;
      });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
ul {
  list-style: none;
  padding-left: 0px;
}

.taxi-list-header {
  color: #10425a;
}

.count {
  width: 50px;
  border-radius: 6px;
  text-align: center;
  font-size: 12px;
  font-weight: 600;
}
</style>
